import * as React from 'react';
import { Provider } from 'react-redux';
import { ErrorLogComponent } from '@cian/error-log-component';
import { UiKitRoot } from '@cian/ui-kit';
import { uaToDeviceType } from '@cian/ui-kit/utils';

import { IApplicationContext } from '../../types/applicationContext';
import { TReduxStore } from '../../types/redux';
import { ApplicationContext } from '../../utils/applicationContext';
import { LocationModalContainer } from '../LocationModalContainer';
import { PageContainer } from '../PageContainer';
import { PromoDetailsModalContainer } from '../PromoDetailsModalContainer';
import { SnackbarContainer } from '../SnackbarContainer';

export interface IApplicationProps {
  context: IApplicationContext;
  reduxStore: TReduxStore;
}

export const Application: React.FC<IApplicationProps> = ({ reduxStore, context }) => {
  const {
    logger,
    custom: { userAgent },
  } = context;

  const deviceType = React.useMemo(() => uaToDeviceType(userAgent || undefined), [userAgent]);

  return (
    <ErrorLogComponent logger={logger}>
      <ApplicationContext.Provider value={context}>
        <UiKitRoot deviceType={deviceType}>
          <Provider store={reduxStore}>
            <PageContainer />
            <PromoDetailsModalContainer />
            <LocationModalContainer />
            <SnackbarContainer />
          </Provider>
        </UiKitRoot>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
};
